import { refreshGrant } from '@sector-labs/fe-auth-keycloak-client';
import { systemClock } from '@sector-labs/fe-auth-core/clock';
import { isPeekableJWT, isPeekedJWTExpired } from '@sector-labs/fe-auth-tokens-peek';
import { getKCBaseURL, kcClientId, kcRealm } from '../utility/env';
import keycloak from './index';

// KeycloakStratAuthenticator.refresh() hardcodes credentials: 'same-origin', which
// strips cookies from the cross-origin token refresh call. This runs the same refresh
// through the package's public refreshGrant/restore APIs, with credentials: 'include'
// so the browser attaches the Keycloak session cookies.
const clock = systemClock();

const refreshWithCookies = async (refreshToken) => {
  // Same silent no-op guard as KeycloakStratAuthenticator.refresh()
  if (!refreshToken || !isPeekableJWT(refreshToken) || isPeekedJWTExpired(clock, refreshToken)) {
    return null;
  }

  const tokenData = await refreshGrant(
    {
      url: getKCBaseURL(),
      realm: kcRealm,
      clientID: kcClientId,
      timeout: 10000,
      clock,
      defaultRequestCredentials: 'include',
    },
    refreshToken,
  );

  await keycloak.restore(tokenData);
  return tokenData;
};

export default refreshWithCookies;
